<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="card shadow">
                    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                        <h6 class="m-0 font-weight-bold text-primary">Filtros</h6>
                    </div>
                    <div class="card-body mb-n5">
                        <div class="row">
                            <div class="col-lg-12 col-sm-12 col-xs-12">
                                <label for="">Usuário*</label>
                                <multiselect v-model="user_multiselect" :options="users_options"
                                    :custom-label="userWithLang" placeholder="Selecione uma opção"
                                    :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                                    @select="handleSelectUser">
                                    <template #noResult>
                                        Nenhum usuário encontrado.
                                    </template>
                                </multiselect>
                            </div>

                        </div>

                        <div class="row mt-2">
                            <div class="col-lg-6 col-sm-6 col-xs-12">
                                <label for="">Atividades iniciadas em</label>
                                <input type="date" class="form-control" v-model="user.from">
                            </div>
                            <div class="col-lg-6 col-sm-6 col-xs-12">
                                <label for="">Atividades finalizadas até</label>
                                <input type="date" class="form-control" v-model="user.to">
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-lg-6 col-sm-6 col-xs-12">
                                <button class="btn btn-primary btnFull" @click="loadData"><i
                                        class="fa fa-check"></i>Aplicar
                                    filtros</button>
                            </div>
                            <div class="col-lg-6 col-sm-6 col-xs-12">
                                <button class="btn btn-danger btnFull" @click="cleanAdvancedSearch"><i
                                        class="fa fa-trash"></i>Limpar
                                    filtros</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-xl-3 col-md-6 mb-4">
                <QuantitativeData color="border-left-success" nameCard="Atividades concluídas" :number="total_completed"
                    icon="fa-check"></QuantitativeData>
            </div>
            <div class="col-xl-3 col-md-6 mb-4">
                <QuantitativeData color="border-left-warning" nameCard="Atividades pendentes" :number="total_pending"
                    icon="fa-spinner">
                </QuantitativeData>
            </div>

            <!-- Earnings (Monthly) Card Example -->
            <div class="col-xl-3 col-md-6 mb-4">
                <QuantitativeData color="border-left-danger" nameCard="Atividades em atraso" :number="total_overdue"
                    icon="fa fa-exclamation"></QuantitativeData>
            </div>

            <!-- Pending Requests Card Example -->
            <div class="col-xl-3 col-md-6 mb-4">
                <QuantitativeData color="border-left-secondary" nameCard="Atividades canceladas"
                    :number="total_cancelled" icon="fa fa-times"></QuantitativeData>
            </div>
        </div>
        <div class="row mt-2 mb-5">
            <div class="col-xl-3 col-md-3 col-sm-12">
                <div class="card shadow mb-4">
                    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                        <h6 class="m-0 font-weight-bold text-primary">Status atividades</h6>
                    </div>
                    <div class="card-body card-body-no-spaccing">
                        <ResumeActivityChart :data="data_pie_resume"></ResumeActivityChart>
                    </div>
                </div>
            </div>
            <div class="col-xl-3 col-md-3 col-sm-12">
                <div class="card shadow mb-4">
                    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                        <h6 class="m-0 font-weight-bold text-primary">Situação geral</h6>
                    </div>
                    <div class="card-body card-body-no-spaccing">
                        <SituationGeneralActivityChart :data="data_pie_general_situation">
                        </SituationGeneralActivityChart>
                    </div>
                </div>
            </div>
            <div class="col-xl-6 col-md-6 col-sm-12">
                <GraphLinearYear :userId="this.user.user_id" v-if="filterLinearYear"> </GraphLinearYear>
                <div v-if="!filterLinearYear" class="card">
                    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                        <h6 class="m-0 font-weight-bold text-primary">Receita x Despesas durante o ano</h6>
                    </div>
                    <div class="card-body card-body-no-spaccing">
                        <div class="row mb-3">
                            <div class="col-xl-12 col-md-12 col-sm-12">
                                <span >Selecione um usuário para carregar os dados</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
         <div class="row mb-5"></div>
    </div>
</template>
<script>

import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import Multiselect from 'vue-multiselect'
import ResumeActivityChart from './resume-activity-chart.vue';
import SituationGeneralActivityChart from './resume-activity-chart.vue';
import QuantitativeData from '@/components/dashboard/quantitative-data.vue'
import GraphLinearYear from './graph-linear-year.vue';

export default {
    components: { Loading, Multiselect, ResumeActivityChart, SituationGeneralActivityChart, QuantitativeData, GraphLinearYear },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            advanced_search: false,
            enable_error_list: false,
            advanced_search_input: {},
            activities: [],
            users_options: [],
            title_modal: 'Nova atividade',
            button_modal: 'Cadastrar',
            label_no_register: 'Selecione um usuário nos filtros para visualizar as suas atividades',
            modalDisplayNewActivity: 'none',
            data_pie_resume: {
                labels: ['Pendentes', 'Finalizadas', 'Atrasadas', 'Canceladas'],
                datasets: []
            },
            data_pie_general_situation: {
                labels: ['Pendentes', 'Finalizadas'],
                datasets: []
            },
            total_completed: '...',
            total_pending: '...',
            total_overdue: '...',
            total_cancelled: '...',
            page: 1,
            last_page: 1,
            total_itens: 0,
            user_multiselect: '',
            users: {},
            filterLinearYear: false,
            activity: {
                'description': '',
                'user_id': '',
                'deadline': ''
            },
            user: {
                'user_id': '',
                'status': '',
                'name': '',
                'from': '',
                'to': '',
                'activity_id': '',
                'year': '2025'
            }
        }
    },
    computed: {
        buttonPagination: function () {
            return this.page > 1;
        },
        isDisabledNewActivity: function () {
            return this.activity.description != '' && this.activity.user_id != null && this.activity.deadline != null;
        }
    },
    mounted() {
        this.isLoading = false;
        const response_uses = this.getUsers();
        response_uses.then(() => {
            this.users_options = this.users.map(item => ({
                key: item.id,
                value: item.name + ' / ' + item.role
            }));

        });
    },
    methods: {
        onCancel() { },
        advancedSearch() {
            this.advanced_search = !this.advanced_search
        },
        closeAdvancedSearch() {
            this.advanced_search = false
        },
        executeAdvancedSearch() {
            this.page = 1;
            this.activities = {};
            this.loadData();
        },
        updateObservation(observation) {
            this.activity.observation = observation;
        },
        cleanAdvancedSearch() {
            this.activities = [];
            this.user.user_id = '';
            this.user_multiselect = '';
            this.user.status = '';
            this.user.from = '';
            this.user.to = '';
            this.user.name = '';
            this.label_no_register = 'Selecione um usuário nos filtros para visualizar as suas atividades';
            this.filterLinearYear = false;
            this.cleanGraph();
        },

        handleSelectUser(option) {
            this.user.user_id = option.key;
            this.activity.user_id = option.key;
            this.user.name = option.value;
        },
        cleanGraph() {
            this.data_pie_resume = {
                labels: ['Pendentes', 'Finalizadas', 'Atrasadas', 'Canceladas'],
                datasets: []
            },
                this.data_pie_general_situation = {
                    labels: ['Pendentes', 'Finalizadas'],
                    datasets: []
                }
        },
        userWithLang({ value }) {
            return value;
        },

        async getUsers() {
            this.isLoading = true;
            const response = api.get('/userListAll', { params: { 'no_client': true } })
                .then((response) => {
                    this.users = response.data.users;
                    this.isLoading = false;
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                })
            return response;
        },
        configureNumber(response) {
            if (response.data.resume_number.total <= 0) {
                this.$notify({
                    title: "Informação",
                    text: "Não foram encontrados registros para os filtros aplicados",
                    type: 'info'
                });
            }
            this.total_completed = response.data.resume_number.total_completed;
            this.total_pending = response.data.resume_number.total_pending;
            this.total_overdue = response.data.resume_number.total_overdue;
            this.total_cancelled = response.data.resume_number.total_cancelled;
        },
        configureResumeChartPie(response) {

            this.data_pie_resume.datasets =
                [
                    {
                        'backgroundColor': ['#F6C23E', '#1CC88A', '#E74A3B', '#858FA7'],
                        'data': response.data.pie_chart
                    }
                ];
        },
        configureSituationGeneralChartPie(response) {
            const data = [response.data.pie_chart[0], response.data.pie_chart[1]];
            this.data_pie_general_situation.datasets =
                [
                    {
                        'backgroundColor': ['#F6C23E', '#1CC88A'],
                        'data': data
                    }
                ];
        },
        loadData() {
            if (this.user.user_id != '') {
                this.cleanGraph();
                this.isLoading = true;
                api.get('activity/' + this.user.user_id + '/graph', {
                    params: {
                        'name': this.user.name,
                        'status': this.user.status,
                        'from': this.user.from,
                        'to': this.user.to,
                        'page': this.page
                    }
                })
                    .then((response) => {
                        this.isLoading = false;
                        this.configureNumber(response);
                        this.configureResumeChartPie(response);
                        this.configureSituationGeneralChartPie(response);
                        this.filterLinearYear = true;
                    }).catch(error => {
                        this.isLoading = false;
                        handleRequestErrors(error.status);
                    })
            } else {
                this.$notify({
                    title: "Informação",
                    text: "Selecione um usuário para filtrar suas atividades",
                    type: 'info'
                });
            }

        },
    }
}
</script>

<style>
.btnFull {
    width: 100%;
}
</style>